import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter()

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/projectunits/';
    const paths = {
        endpointSave: config.endpoints.backend + 'projectunits/save',
        endpointGetById: config.endpoints.backend + 'projectunits/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllProjectUnits: config.endpoints.backend + 'projectunits/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Unidade",
        labelTitleEdit: "Editar Unidade",
        labelTitleView: 'Visualizar Unidade'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_and_entity',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true,
                        cnes_unique: true
                    },
                    columnSize: 12,
                },
                {

                    name: 'units',
                    type: 'multiApiSearch',
                    label: 'Unidade - Pesquise o CNES',
                    required_input_search: true,
                    endpoint: `${config.integration.governanceroom}governanceroom/establishments/getbycnes`,
                    endpoint_method: "post",
                    endpoint_filter: 'cnes',
                    response_type: "multiple",
                    label_column: "Nome",
                    label_path: "no_fantasia",
                    value_path: "",
                    unique: "co_cnes",
                    validations: {
                        required: true,
                        cnes_unique: true
                    },
                    items_limit: 1,
                    columnSize: 12
                }
            ],
            customValidators: {
                cnes_unique: async (value, options, key, attributes) => {
                    if (value.length >= 7) {
                        const cnesExists = await Fetch.post(paths.endpointGetAllProjectUnits, { filter: { co_cnes: attributes.units[0].co_cnes, pdc_project_id: value } })
                        console.log(cnesExists)
                        if (cnesExists.length > 0) {
                            if (id && cnesExists[0].pdc_project_id == value) {
                                return '';
                            } else {
                                return '^Essa unidade já existe nesse projeto.';
                            }
                        }
                    } else {
                        return '';
                    }
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
